module.exports = __webpack_public_path__ + "static/media/messa2.b78f89d9.jpg";